import React from 'react';

/**
 * The second series of a two-series chart differs from the first by dash and
 * point shape, not only by colour, so it reads for colour-blind viewers.
 */
export const SECOND_SERIES_DASH = '6 4';

export function squareDot(fill: string, size: number) {
  return function SquareDot({ cx, cy }: { cx?: number; cy?: number }) {
    if (cx == null || cy == null) {
      return <g />;
    }
    return (
      <rect
        x={cx - size / 2}
        y={cy - size / 2}
        width={size}
        height={size}
        fill={fill}
      />
    );
  };
}

/** Diagonal stripes for a bar series, matching the hatch legend swatch. */
export function HatchPattern({ id, color }: { id: string; color: string }) {
  return (
    <pattern
      id={id}
      patternUnits="userSpaceOnUse"
      width="6"
      height="6"
      patternTransform="rotate(45)"
    >
      <rect width="6" height="6" fill={color} />
      <line x1="1" y1="0" x2="1" y2="6" stroke="#ffffff" strokeWidth="2" />
    </pattern>
  );
}

export function hatchSwatchStyle(color: string): React.CSSProperties {
  return {
    backgroundImage: `repeating-linear-gradient(-45deg, ${color} 0 3px, #ffffff 3px 5px)`,
  };
}
